import React, { useState } from 'react';
import AtlasV2DorisSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisSplineChart';
import { METRICTYPE } from 'src/utils/entityDefinitions';

const fieldOptions = [
  {
    label: 'Market Share of Retail Sales',
    id: 'retailSales',
    fieldName: 'retailSales'
  },
  {
    label: '1P Market Share of Retail Sales',
    id: 'firstPartySales/retailSales',
    fieldName: 'firstPartySales'
  },
  {
    label: '1P Market Share of 1P Retail Sales',
    id: 'firstPartySales/firstPartySales',
    fieldName: 'firstPartySales'
  },
  {
    label: '3P Market Share of Retail Sales',
    id: 'ThirdPartySales',
    fieldName: 'ThirdPartySales'
  },
  {
    label: '3P Market Share of 3P Retail Sales',
    id: 'ThirdPartySales/ThirdPartySales',
    fieldName: 'ThirdPartySales'
  }
];

const AtlasV2SalesMarketShareOfRetailSalesChart = () => {
  const [selectedField, setSelectedField] = useState(fieldOptions[0]);
  return (
    <AtlasV2DorisSplineChart
      queryKey="RetailSalesMarketShareSplineChart"
      title={selectedField.label}
      methodName="sales/GetSalesMetrics"
      metricTypeDisplay={METRICTYPE.PERCENT}
      metricType={selectedField.fieldName}
      showMarketShare={true}
      marketShareRequestBuilder={(params) => {
        switch (selectedField.id) {
          case 'retailSales':
          case 'ThirdPartySales/ThirdPartySales':
            return {
              ...params,
              brandIds: []
            };
          case 'firstPartySales/retailSales':
          case 'ThirdPartySales':
            return {
              ...params,
              brandIds: [],
              metricType: 'retailSales'
            };
          case 'firstPartySales/firstPartySales':
            return {
              ...params,
              brandIds: [],
              metricType: 'firstPartySales'
            };
          default:
            break;
        }
        return {
          ...params,
          brandIds: []
        };
      }}
      beaconChartWithLegendOverride={(props, metric) => {
        return {
          ...props,
          singleDropdownProps: {
            onChange: (s) => setSelectedField(fieldOptions.find((option) => option.id === s.id)),
            defaultLabel: selectedField.label,
            selectedId: selectedField.id,
            buttonVariant: 'title',
            options: fieldOptions,
            shouldShowFullItemText: true
          }
        };
      }}
    />
  );
};

export default AtlasV2SalesMarketShareOfRetailSalesChart;
